import * as yup from 'yup';

export const ableitungsrohreSchema = yup.object({
  innerhalb: yup.string().default(''),
  ausserhalb: yup.string().default(''),
  dichtheitsnachweisVorhanden: yup.boolean().default(false),
});
